import { AFFILIATE_DASHBOARD_API } from 'modules/affiliate-dashboard/api/affiliate-dashboard-api'
import { AffiliateDashboardStatisticInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-statistic-interface'
import { VendorId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-vendors-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useAffiliateDashboardStatistic = (vendorId?: VendorId) => {
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateDashboardStatisticInterface>({
    method: RequestMethodsEnum.get,
  })
  const { user } = useUser()
  return useSWR(() => {
    if (!user) return
    if (vendorId) {
      return `${AFFILIATE_DASHBOARD_API}/stats/${vendorId}`
    } else {
      return `${AFFILIATE_DASHBOARD_API}/stats`
    }
  }, fetcher)
}
